import React, { useState } from 'react';
import classes from './LuckyBirthday.module.css';

const LuckyBirthday = () => {
  const [dob, setDob] = useState('');
  const [luckyNumber, setLuckyNumber] = useState('');
  const [msg, setMsg] = useState('');
  const [ilstr, setIlstr] = useState('');

  const checkLuck = (e) => {
    e.preventDefault();
    setIlstr('');
    console.log(luckyNumber);
    if (dob === '') {
      setMsg('Enter your date of birth.');
      return;
    } else if (luckyNumber === '') {
      setMsg('Enter your lucky number.');
      return;
    }
    const total = sum(dob);
    if (total % luckyNumber === 0) {
      setMsg('Yay...Your birthday is lucky!!🎉');
      setIlstr('/assets/lucky.svg');
      return;
    }
    setMsg(
      'Oops! Your birthday is not lucky! Time to change your lucky number🥸'
    );
    setIlstr('/assets/unlucky.svg');
  };

  const sum = (dob) => {
    let dateNumber = dob.replaceAll('-', '');
    let dateSum = 0;

    for (let i = 0; i < dateNumber.length; i++) {
      dateSum = dateSum + Number(dateNumber.charAt(i));
    }
    return dateSum;
  };

  return (
    <div>
      <div className={classes.main}>
        <h1>Find if your birthday is lucky or not here.</h1>
        <div className={classes['main-form']}>
          <form action="" onSubmit={checkLuck}>
            <input
              type="date"
              onChange={(e) => {
                setDob(e.target.value);
              }}
              placeholder="Date of birth"
            />
            <input
              type="number"
              onChange={(e) => {
                setLuckyNumber(e.target.value);
              }}
              placeholder="Enter your lucky number"
              min="1"
              step="1"
            />
            <button>CHECK LUCK</button>
            <p>NOTICE: WE DO NOT STORE YOUR DATA!</p>
          </form>
          {msg}
        </div>

        <div className={classes.ilstr}>
          <div>
            <img src={`${ilstr}`} alt="" className={classes.img} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LuckyBirthday;
